/* SPH – zusätzlicher Produkt-Tab „Versand & Lieferung“ */
(function () {
  var tpl = document.getElementById('sph-shiptab');
  var tabs = document.querySelector('.sph-tabs');
  if (!tpl || !tabs) return;

  var buttons = Array.prototype.slice.call(tabs.children).filter(function (el) {
    return el.tagName === 'BUTTON' || el.tagName === 'A';
  });
  if (!buttons.length) return;

  var panels = Array.prototype.slice.call(document.querySelectorAll('.sph-tabp'));
  var model = buttons[0];

  var btn = document.createElement(model.tagName);
  btn.className = model.className;
  if (btn.tagName === 'BUTTON') btn.type = 'button';
  btn.textContent = 'Versand & Lieferung';
  btn.removeAttribute('aria-selected');
  tabs.appendChild(btn);

  var panel = document.createElement('div');
  panel.className = panels.length ? panels[0].className : 'sph-tabp';
  panel.appendChild(tpl.content.cloneNode(true));
  panel.hidden = true;
  var host = panels.length ? panels[panels.length - 1] : tabs;
  host.insertAdjacentElement('afterend', panel);

  function activeClass(el) {
    return (el.className.match(/is-[a-z]+/) || ['is-on'])[0];
  }
  var cls = buttons[0].className.indexOf('is-') > -1 ? activeClass(buttons[0]) : 'is-on';

  function openOwn() {
    buttons.forEach(function (b) { b.classList.remove(cls); b.setAttribute('aria-selected', 'false'); });
    panels.forEach(function (p) { p.hidden = true; });
    btn.classList.add(cls);
    btn.setAttribute('aria-selected', 'true');
    panel.hidden = false;
  }
  function closeOwn() {
    btn.classList.remove(cls);
    btn.setAttribute('aria-selected', 'false');
    panel.hidden = true;
  }

  btn.addEventListener('click', function (e) { e.preventDefault(); openOwn(); });
  buttons.forEach(function (b) { b.addEventListener('click', function () { closeOwn(); }); });
})();
